<template>
    <div class="col s12 padding-top-half padding-bottom-half">

        <div v-show="selected_option == false" class="row">
            <h1 class="padding-top-half padding-bottom-half">Report</h1>
            <div class="row">
                <h6>What is your Mobile Number?</h6>
                <div class="col s12 m10 offset-m1 l6 offset-l3 padding-top-half padding-bottom-half">
                    <div class="col s3 l2 padding-left-0 padding-right-0 right-align font-20 padding-top-1">+267</div>
                    <div class="input-field col s7 l10 padding-top-half padding-bottom-half">
                        <input placeholder="Enter you Phone Number Here" id="icon_telephone" type="tel"  class="validate" v-model="phone"  required="required" autocomplete="off">
                        <label for="icon_telephone">Phone Number</label>
                    </div>
                </div>
            </div>
            <div v-show="phoneIsValid" class="row">
                <h6 >What type of establishment are you reporting?</h6>
                <div class="col s12 m10 offset-m1 padding-top-half padding-bottom-half" >
                    <div class="col s6 center">
                        <button class="btn-large grey darken-2 col s12" @click.prevent="selectOption('ReportingComponent')">
                            Liquor Outlet
                        </button>
                    </div>
                    <div class="col s6 center">
                        <button class="btn-large grey darken-2 col s12" @click.prevent="selectOption('ReportOther')" >
                            Other
                        </button>
                    </div>
                </div>
            </div>
            <div class="col s4 offset-s4 l2 offset-l5 center" v-show="!phoneIsValid" >
                <img src="../../public/baia_logo.jpg"
                     alt="Botswana Alcohol Industry Association"
                     class="responsive-img"
                />
            </div>


        </div>
        <loading-component></loading-component>
        <Component v-bind:is="component" v-if="stage"></Component>
        <MessageModalComponent :messages="messages"></MessageModalComponent>

    </div>
</template>
<script>
    import ReportingComponent from "@/components/ReportingComponent.vue"
    import ReportOther from "@/components/ReportOther.vue"
    import SearchBarSelect from "@/components/SearchBarSelect"
    import LocationSelect from "@/components/LocationSelect"
    import TakePic from "@/components/TakePic"
    import LoadingComponent from "@/components/materialize/LoadingComponent.vue"
    import MessageModalComponent from "@/components/materialize/MessageModalComponent.vue";
    import {mapState} from "vuex"
    import http from "../http-common"

    export default{
        components: {
            'ReportingComponent':ReportingComponent,
            'ReportOther':ReportOther,
            'SearchBarSelect': SearchBarSelect,
            'LocationSelect':LocationSelect,
            'TakePic':TakePic,
            'MessageModalComponent':MessageModalComponent,
            'LoadingComponent':LoadingComponent

        },
        data()
        {
            return {
                phone:null,
                component:"",
                disable:false,
                stage:[],
                selected_option: false,
                errors:[],
                compatibility: false,
                page_loaded: false,
                OSName: "",
                header : [],
                os: [],
                browser: [],
                device: {
                    os: null,
                    browser: null
                },
                compatibilityIssueList: [
                    {
                        browser: "Chrome",
                        os: "iPhone"
                    }
                ]
            }
        },
        methods: {
            selectOption: function(_name)
            {
                if(!this.checkCompatibility())
                {
                    this.$store.dispatch("GET_MESSAGES", ["Browser compatibility issue detected.", "Safari browser recommended for iOS."]);
                    return false;
                }
                this.selected_option = true;
                this.component = _name;
                this.$store.dispatch("SET_PHONE", this.phone);
                if(_name === "ReportingComponent")
                {
                    this.$store.dispatch("SET_REPORT_LIQUOR_OUTLET", true);
                }
                else
                {
                    this.$store.dispatch("SET_REPORT_LIQUOR_OUTLET", false);
                }
            },
            checkCompatibility: function()
            {
                if(typeof window.navigator === "undefined" || window.navigator === null || typeof window.navigator.mediaDevices === "undefined" || window.navigator.mediaDevices === null)
                {
                   //console.log("Incompatible device 1");
                    return false;
                }
                if(typeof window.navigator.mediaDevices.getUserMedia === "undefined" || window.navigator.mediaDevices.getUserMedia === null)
                {
                   //console.log("Incompatible Device 2");
                    return false;
                }

                return true;
            },
            checkOS: function()
            {
                this.OSName = "Unknown OS";
                if (navigator.appVersion.indexOf("Win")!=-1) this.OSName="Windows";
                if (navigator.appVersion.indexOf("Mac")!=-1) this.OSName="MacOS";
                if (navigator.appVersion.indexOf("X11")!=-1) this.OSName="UNIX";
                if (navigator.appVersion.indexOf("Linux")!=-1) this.OSName="Linux";
            },
            matchNavigatorData : function(string, data) {
                let i = 0,
                    j = 0,
                    //html = '',
                    regex,
                    regexv,
                    match,
                    matches,
                    version;

                for (i = 0; i < data.length; i += 1) {
                    regex = new RegExp(data[i].value, 'i');
                    match = regex.test(string);
                    if (match) {
                        //regexv = new RegExp(data[i].version + '[- /:;]([\d._]+)', 'i');
                        regexv = new RegExp(data[i].version + '[- /:;]([._]+)', 'i');
                        matches = string.match(regexv);
                        version = '';
                        if (matches) { if (matches[1]) { matches = matches[1]; } }
                        if (matches) {
                            matches = matches.split(/[._]+/);
                            for (j = 0; j < matches.length; j += 1) {
                                if (j === 0) {
                                    version += matches[j] + '.';
                                } else {
                                    version += matches[j];
                                }
                            }
                        } else {
                            version = '0';
                        }
                        return {
                            name: data[i].name,
                            version: parseFloat(version)
                        };
                    }
                }
                return { name: 'unknown', version: 0 };
            },
            initNavigatorData: function()
            {
                this.header = [
                    navigator.platform,
                    navigator.userAgent,
                    navigator.appVersion,
                    navigator.vendor,
                    window.opera
                ];
                this.browser = [
                    { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
                    { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
                    { name: 'Safari', value: 'Safari', version: 'Version' },
                    { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
                    { name: 'Opera', value: 'Opera', version: 'Opera' },
                    { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
                    { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
                ];
                this.os = [
                    { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
                    { name: 'Windows', value: 'Win', version: 'NT' },
                    { name: 'iPhone', value: 'iPhone', version: 'OS' },
                    { name: 'iPad', value: 'iPad', version: 'OS' },
                    { name: 'Kindle', value: 'Silk', version: 'Silk' },
                    { name: 'Android', value: 'Android', version: 'Android' },
                    { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
                    { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
                    { name: 'Macintosh', value: 'Mac', version: 'OS X' },
                    { name: 'Linux', value: 'Linux', version: 'rv' },
                    { name: 'Palm', value: 'Palm', version: 'PalmOS' }
                ];
            },
            getDeviceUserAgent: function()
            {
                return this.header.join(' ');
            },
            getDeviceOS: function()
            {
                return this.matchNavigatorData(this.getDeviceUserAgent(), this.os);

            },
            getDeviceBrowser: function()
            {
                return this.matchNavigatorData(this.getDeviceUserAgent(), this.browser);
            }

        },
        computed: {
            ...mapState({
                messages: state => state.messages,
                actionName: state => state.actionName,
            }),
            phoneIsValid :function () {
                if(typeof this.phone !== "undefined" && this.phone !== null && this.phone.isNumber() && this.phone.startsWith(7) && this.phone.length === 8)
                {
                    return true;
                }
                return false;
            },
            iOSDetected: function()
            {
                return (this.OSName === "MacOS");
            },

            deviceIsCompatible: function()
            {
                if(this.device.os === null || this.device.browser === null)
                    return true;

                let _arrFound = this.compatibilityIssueList.filter(function(_item)
                {
                    return (_item.browser == this.device.browser.name && _item.os == this.device.os.name);
                });

                return (_arrFound.length>0);
            }
        },

        created()
        {
            this.initNavigatorData();
            this.device.os = this.getDeviceOS();
            this.device.browser = this.getDeviceBrowser();
        },
        mounted()
        {

            this.compatibility = this.checkCompatibility();
            this.page_loaded = true;
            http.interceptors.response.use((response)=>{
                    //console.log("* Response"+JSON.stringify(response));
                    if(response.data.success == false)
                    {
                        return Promise.reject(response);
                    }
                    return response
                },
                (error)=>{

                    var response = {
                        data: {
                            messages : [error.message]
                        },
                        message: error.message,
                    };

                    //console.log("* Error Response"+JSON.stringify(error));

                    return Promise.reject(response);
                }
            );
        }
    }
</script>